import script from "./FormEncontroInputs.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEncontroInputs.vue?vue&type=script&setup=true&lang=js"

import "./FormEncontroInputs.vue?vue&type=style&index=0&id=208730c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208730c2"]])

export default __exports__